import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormInputComponent } from '../../form-field/input.component';
import { TranslateModule } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'qa-sample-answer',
  imports: [FormInputComponent, TranslateModule],
  templateUrl: './sample-answer.component.html',
  styleUrl: './sample-answer.component.scss',
})
export class SampleAnswerComponent implements OnChanges {
  @Input() info: string;
  @Output() textBoxValueChange = new EventEmitter<string>();
  form: UntypedFormGroup;
  explanationOpen = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.info && this.info) {
      this.form = new UntypedFormGroup({
        textBoxData: new UntypedFormControl(this.info),
      });
    }
  }

  handleTextBoxTextChange($event) {
    if ($event !== this.info) {
      this.textBoxValueChange.emit($event);
    }
  }
}
